import { createSlice } from "@reduxjs/toolkit"
import { setLogin, setLogout } from "./authSlice"

const initialState = {
  unreadCount: 0,
  latestUnread: [],
  lastSyncedAt: null,
  pulse: 0,
}

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationInbox: (state, action) => {
      const items = Array.isArray(action.payload?.items)
        ? action.payload.items
        : []
      const unreadCount = Number(action.payload?.unreadCount)
      state.latestUnread = items
      state.unreadCount = Number.isFinite(unreadCount)
        ? Math.max(0, Math.floor(unreadCount))
        : items.length
      state.lastSyncedAt = Date.now()
    },
    markNotificationRead: (state, action) => {
      const id = action.payload
      state.latestUnread = state.latestUnread.filter(item => item.id !== id)
      state.unreadCount = Math.max(0, state.unreadCount - 1)
    },
    clearUnreadInbox: state => {
      state.latestUnread = []
      state.unreadCount = 0
      state.lastSyncedAt = Date.now()
    },
    bumpNotificationPulse: state => {
      state.pulse += 1
    },
  },
  extraReducers: builder => {
    builder.addCase(setLogout, () => initialState)
    builder.addCase(setLogin, () => initialState)
  },
})

export const {
  setNotificationInbox,
  markNotificationRead,
  clearUnreadInbox,
  bumpNotificationPulse,
} = notificationsSlice.actions

export default notificationsSlice.reducer
